export default __webpack_public_path__ + "static/media/collaborate6.f5575b72.png";